import { Injectable } from '@angular/core';

import { Action, createSelector, State, StateContext } from '@ngxs/store';

import { MarkSuggestionShownAction } from './suggestion.action';
import { SuggestionStateModel } from './suggestion.model';

@State<SuggestionStateModel>({
  name: 'suggestion',
  defaults: {
    shownByStudent: {}
  }
})
@Injectable()
export class SuggestionState {
  static wasShown(studentId: number) {
    return createSelector(
      [SuggestionState],
      (state: SuggestionStateModel) => !!state.shownByStudent?.[studentId]
    );
  }

  @Action(MarkSuggestionShownAction)
  markAsShown(
    ctx: StateContext<SuggestionStateModel>,
    action: MarkSuggestionShownAction
  ): void {
    const { shownByStudent } = ctx.getState();

    ctx.patchState({
      shownByStudent: { ...shownByStudent, [action.studentId]: true }
    });
  }
}
